module.exports = {"632725100":"香达镇","632725200":"白扎乡","632725201":"吉曲乡","632725202":"娘拉乡","632725203":"毛庄乡","632725204":"觉拉乡","632725205":"东坝乡","632725206":"尕羊乡","632725207":"吉尼赛乡","632725208":"着晓乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632725.json
// module id = 3156
// module chunks = 0